import {Validator} from '@/type/validation/result';
import {必須入力} from '@/type/validation/validator';
import {特別メニュー区分型, 独自仕様区分型} from '@/type/authentication/custom';

export interface ログインアカウント型 {
  医療機関コード: string;
  部署コード: string;
  部署名: string;
  利用者コード: string;
  氏名: string;
  権限レベル区分: 権限レベル区分型;
  システム利用区分: システム利用区分型;
  備蓄品採用フラグ: 備蓄品採用フラグ型;
  発注書自動表示フラグ: 発注書自動表示フラグ型;
  バラ管理フラグ: バラ管理フラグ型;
  有効期限管理フラグ: 有効期限管理フラグ型;
  棚卸有効期限非表示フラグ: 棚卸有効期限非表示フラグ型;
  HT移動一括取込フラグ: HT移動一括取込フラグ型;
  HT払出一括取込フラグ: HT払出一括取込フラグ型;
  外部連携利用フラグ: 外部連携利用フラグ型;
  譲渡譲受利用フラグ: 譲渡譲受利用フラグ型;
  独自コード利用フラグ: 独自コード利用フラグ型;
  独自区分利用フラグ: 独自区分利用フラグ型;
  独自仕様区分: 独自仕様区分型 | null;
  特別メニュー区分一覧: 特別メニュー区分型[];
}

export enum 権限レベル区分型 {
  マスター = 'マスター',
  管理者 = '管理者',
  利用者 = '利用者',
}

export enum システム利用区分型 {
  発注のみ = '発注のみ',
  発注と在庫管理 = '発注と在庫管理',
}

export enum 備蓄品採用フラグ型 {
  無効 = '無効',
  有効 = '有効',
}

export enum 発注書自動表示フラグ型 {
  無効 = '無効',
  有効 = '有効',
}

export enum バラ管理フラグ型 {
  箱管理 = '箱管理',
  バラ管理 = 'バラ管理',
}

export enum 有効期限管理フラグ型 {
  管理しない = '管理しない',
  管理する = '管理する',
}

export enum 棚卸有効期限非表示フラグ型 {
  表示 = '表示',
  非表示 = '非表示',
}

export enum HT移動一括取込フラグ型 {
  即時 = '即時取込',
  一括取込 = '一括取込',
}

export enum HT払出一括取込フラグ型 {
  即時 = '即時取込',
  一括取込 = '一括取込',
}

export enum 外部連携利用フラグ型 {
  利用する = '利用する',
  利用しない = '利用しない',
}

export enum 譲渡譲受利用フラグ型 {
  利用する = '利用する',
  利用しない = '利用しない',
}

export enum 独自コード利用フラグ型 {
  利用する = '利用する',
  利用しない = '利用しない',
}

export enum 独自区分利用フラグ型 {
  利用する = '利用する',
  利用しない = '利用しない',
}

export const 認証入力バリデータ一覧: Validator[] = [
  {
    name: '医療機関コード',
    constraints: [
      {method: 必須入力, message: '医療機関コードは入力必須項目です'},
    ],
  },
  {
    name: '利用者コード',
    constraints: [
      {method: 必須入力, message: '利用者コードは入力必須項目です'},
    ],
  },
  {
    name: 'パスワード',
    constraints: [
      {method: 必須入力, message: 'パスワードは入力必須項目です'},
    ],
  },
];
